// extracted by mini-css-extract-plugin
export default {"root":"PageAction_root__Z8uAT","cardsEventDetail":"PageAction_cardsEventDetail__SAfE7","box":"PageAction_box__b6Mwl","buttonsContainer":"PageAction_buttonsContainer__0MjEb"};